import axios, { AxiosInstance, AxiosResponse } from "axios";
import { BASE_URL } from "../common/common";
import toast from "react-hot-toast";

export class BaseService {
    httpClient: AxiosInstance;

    constructor(baseUrl: any = BASE_URL) {
        this.httpClient = axios.create({ baseURL: baseUrl });

        // Request Interceptor - Attach Token
        this.httpClient.interceptors.request.use((request: any) => {
            const token = localStorage.getItem("motosop") ;
            const entityId = localStorage.getItem("entity_id") ;
            const userId = localStorage.getItem("userId") ;

                request.headers = {
                    ...request.headers,
                    ...(token && { Authorization: `Bearer ${token}` }),
                    ...(userId && { userId }),        
                    ...(entityId && { entityId }),
                };
            
            return request;
        });

        // Response Interceptor - Handle Unauthorized Errors
        this.httpClient.interceptors.response.use(
            (response: AxiosResponse) => response,
            (error: any) => {
                if (error.response?.status === 401) {
                    this.autoLogout();
                }
                return Promise.reject(error);
            }
        );
    }

    async autoLogout(): Promise<void> {
        localStorage.clear();
        toast("Session Expired. Please log in again.");
        window.location.href = "/login"; // Redirect to login
    }
}
